var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ag-overlay-loading-center",attrs:{"data-cy":"grid-loading-overlay"}},[_c('font-awesome-icon',{attrs:{"size":"4x","icon":['fal', 'spinner'],"spin":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }